(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    (function () {
    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var day = result.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return result;
    }

    function run() {
      var nodes = document.querySelectorAll('[data-delivery]:not([data-ready])');
      nodes.forEach(function (el) {
        el.setAttribute('data-ready', '');
        var min = parseInt(el.dataset.min, 10) || 0;
        var max = parseInt(el.dataset.max, 10) || 0;
        if (min <= 0) { el.hidden = true; return; }
        var lang = el.dataset.lang || 'fr';
        var fmt;
        try { fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' }); }
        catch (e) { fmt = new Intl.DateTimeFormat('fr', { day: 'numeric', month: 'short' }); }
        var now = new Date();
        var span = el.querySelector('[data-delivery-text]');
        if (span) {
          span.textContent = el.dataset.template
            .replace('__MIN__', fmt.format(addBusinessDays(now, min)))
            .replace('__MAX__', fmt.format(addBusinessDays(now, max)));
        }
        el.hidden = false;
      });
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    // Dual-handle price range slider. Syncs two thumbs to the hidden number
  // inputs the facet form submits (empty at the bounds = no filter), then
  // dispatches 'input' so <facet-filters> applies via its debounced handler.
  class PriceSlider extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 1500;
      this.minThumb = this.querySelector('[data-thumb="min"]');
      this.maxThumb = this.querySelector('[data-thumb="max"]');
      this.fill = this.querySelector('[data-fill]');
      this.minLabel = this.querySelector('[data-min-label]');
      this.maxLabel = this.querySelector('[data-max-label]');
      this.hMin = this.querySelector('[data-bound="min"]');
      this.hMax = this.querySelector('[data-bound="max"]');
      if (!this.minThumb || !this.maxThumb) return;
      this.sym = (this.minLabel.textContent.replace(/[\d\s.,]/g, '') || '');
      this.minThumb.addEventListener('input', () => this.onInput('min'));
      this.maxThumb.addEventListener('input', () => this.onInput('max'));
      this.paint();
    }
    onInput(which) {
      let lo = parseInt(this.minThumb.value, 10);
      let hi = parseInt(this.maxThumb.value, 10);
      if (lo > hi) {
        if (which === 'min') { lo = hi; this.minThumb.value = lo; }
        else { hi = lo; this.maxThumb.value = hi; }
      }
      this.paint();
      this.hMin.value = lo <= 0 ? '' : String(lo);
      this.hMax.value = hi >= this.max ? '' : String(hi);
      this.hMin.dispatchEvent(new Event('input', { bubbles: true }));
    }
    paint() {
      const lo = parseInt(this.minThumb.value, 10);
      const hi = parseInt(this.maxThumb.value, 10);
      const a = (lo / this.max) * 100;
      const b = (hi / this.max) * 100;
      if (this.fill) { this.fill.style.left = a + '%'; this.fill.style.width = (b - a) + '%'; }
      if (this.minLabel) this.minLabel.textContent = lo + ' ' + this.sym;
      if (this.maxLabel) this.maxLabel.textContent = hi + ' ' + this.sym;
    }
  }
  if (!customElements.get('price-slider')) customElements.define('price-slider', PriceSlider);

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.form = this.querySelector('[data-facet-form]');
      this.toggleBtn = this.querySelector('[data-filters-toggle]');
      this.panel = this.querySelector('[data-filters-panel]');
      this.desktopMql = window.matchMedia('(min-width: 60em)');
      this.priceTimer = null;
      this.controller = null;

      this.onChange = (e) => {
        if (e.target.matches('[data-price-input]')) return;
        if (e.target.closest('[data-facet-form]')) this.applyFromForm();
      };
      this.onInput = (e) => {
        if (!e.target.matches('[data-price-input]')) return;
        window.clearTimeout(this.priceTimer);
        this.priceTimer = window.setTimeout(() => this.applyFromForm(), 600);
      };
      this.onClick = (e) => {
        const link = e.target.closest('[data-facet-link]');
        if (link) { e.preventDefault(); this.apply(link.href); return; }
        if (e.target.closest('[data-filters-toggle]')) this.toggleDrawer(true);
        if (e.target.closest('[data-filters-close]')) this.toggleDrawer(false);
      };
      this.onKeydown = (e) => {
        if (this.dataset.filtersOpen !== 'true') return;
        if (e.key === 'Escape') { this.toggleDrawer(false); return; }
        if (this.panel) window.WMFocusTrap.handle(this.panel, e);
      };
      this.onPop = () => { this.dataset.filtersOpen = 'false'; this.apply(window.location.href, false); };
      this.syncSidebar = () => {
        if (this.panel) this.panel.inert = !this.desktopMql.matches && this.dataset.filtersOpen !== 'true';
      };

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('popstate', this.onPop);
      this.desktopMql.addEventListener('change', this.syncSidebar);
      this.syncSidebar();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('popstate', this.onPop);
      this.desktopMql.removeEventListener('change', this.syncSidebar);
      document.documentElement.style.overflow = '';
    }

    toggleDrawer(open) {
      this.dataset.filtersOpen = open ? 'true' : 'false';
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (this.panel) {
        if (open) {
          this.panel.setAttribute('role', 'dialog');
          this.panel.setAttribute('aria-modal', 'true');
        } else {
          this.panel.removeAttribute('role');
          this.panel.removeAttribute('aria-modal');
        }
      }
      this.syncSidebar();
      if (open) {
        this.trigger = document.activeElement;
        const first = this.panel ? window.WMFocusTrap.focusable(this.panel)[0] : null;
        if (first) window.setTimeout(() => first.focus(), 80);
      } else if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus();
      }
    }

    applyFromForm() {
      const params = new URLSearchParams(new FormData(this.form));
      for (const [key, value] of Array.from(params.entries())) {
        if (value === '') params.delete(key);
      }
      this.apply(`${this.form.action}?${params.toString()}`);
    }

    async apply(url, push = true) {
      const target = new URL(url, window.location.origin);
      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;

      const active = document.activeElement;
      const wasLink = active && active.tagName === 'A';
      let restoreSel = null;
      if (active && active.name) {
        restoreSel = `[name="${window.CSS.escape(active.name)}"]`;
        if (active.type === 'checkbox' && active.value) restoreSel += `[value="${window.CSS.escape(active.value)}"]`;
      }

      this.setAttribute('data-loading', '');
      const fetchUrl = new URL(target);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      try {
        const response = await fetch(fetchUrl.toString(), { signal: controller.signal });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        ['[data-shape-selector]', '[data-material-selector]', '[data-active-filters]', '[data-facet-groups]', '[data-product-grid]', '[data-result-count]', '[data-apply-count]', '[data-pagination]'].forEach((sel) => {
          const fresh = parsed.querySelector(sel);
          const current = this.querySelector(sel);
          if (current) current.innerHTML = fresh ? fresh.innerHTML : '';
        });
        if (push) window.history.pushState({}, '', target.toString());

        const restore = restoreSel ? this.querySelector(restoreSel) : null;
        if (restore) {
          restore.focus();
        } else if (wasLink) {
          const count = this.querySelector('[data-result-count]');
          if (count) { count.setAttribute('tabindex', '-1'); count.focus(); }
        }
        const top = this.querySelector('[data-results-top]');
        if (top && push && wasLink) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        if (e.name === 'AbortError') return;
      } finally {
        if (this.controller === controller) {
          this.controller = null;
          this.removeAttribute('data-loading');
        }
      }
    }
  }
  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["focus-trap"] && !Shopify.designMode) return;
  try {
    window.WMFocusTrap = {
    selector:
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    focusable(root) {
      return Array.from(root.querySelectorAll(this.selector)).filter(
        (el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length
      );
    },
    handle(root, event) {
      if (event.key !== 'Tab') return;
      const items = this.focusable(root);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["localization-selectors"] && !Shopify.designMode) return;
  try {
    class LocalizationForm extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('[data-localization-select]');
      if (select) select.addEventListener('change', () => this.closest('form').submit());
    }
  }
  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.suggestUrl = this.dataset.suggestUrl;
      this.controller = null;
      this.minLength = 2;
      this.debounce = null;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onDocClick = (e) => {
        if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); this.open(); }
        if (e.target.closest('[data-search-close]')) this.close();
      };
      this.onDocKeydown = (e) => {
        if (this.dataset.open !== 'true') return;
        if (e.key === 'Escape') { this.close(); return; }
        window.WMFocusTrap.handle(this, e);
      };

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onDocKeydown);
      this.input.addEventListener('input', () => this.onInput());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onDocKeydown);
    }

    open() {
      this.trigger = document.activeElement;
      this.dataset.open = 'true';
      this.removeAttribute('inert');
      document.querySelectorAll('[data-search-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => this.input.focus(), 120);
    }

    close() {
      if (this.controller) this.controller.abort();
      this.dataset.open = 'false';
      this.setAttribute('inert', '');
      document.querySelectorAll('[data-search-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    }

    onInput() {
      const query = this.input.value.trim();
      window.clearTimeout(this.debounce);
      if (query.length < this.minLength) {
        if (this.controller) this.controller.abort();
        this.results.innerHTML = '';
        return;
      }
      this.debounce = window.setTimeout(() => this.search(query), 240);
    }

    async search(query) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product,collection,page,article',
        'resources[limit]': '6',
        section_id: 'predictive-search',
      });
      try {
        const response = await fetch(`${this.suggestUrl}?${params}`, { signal: this.controller.signal });
        if (!response.ok) return;
        const text = await response.text();
        // Ignore stale responses whose query no longer matches the input.
        if (this.input.value.trim() !== query) return;
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const fresh = parsed.querySelector('[data-predictive-results]');
        if (fresh) this.results.innerHTML = fresh.innerHTML;
      } catch (e) {
        if (e.name !== 'AbortError') this.results.innerHTML = '';
      }
    }
  }
  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prefetch"] && !Shopify.designMode) return;
  try {
    (function () {
    var conn = navigator.connection;
    if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
    if (!('IntersectionObserver' in window)) return;

    var done = {};
    var timer = null;

    function prefetch(url) {
      if (done[url]) return;
      done[url] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }

    function candidate(target) {
      var a = target.closest ? target.closest('a[href]') : null;
      if (!a || a.origin !== window.location.origin) return;
      if (a.hasAttribute('data-no-prefetch')) return;
      if (!/\/(products|collections|pages|blogs)\//.test(a.pathname)) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { prefetch(a.href); }, 80);
    }

    document.addEventListener('pointerover', function (e) { candidate(e.target); }, { passive: true });
    document.addEventListener('touchstart', function (e) { candidate(e.target); }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-gallery-viewport]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.dialog = this.querySelector('[data-zoom-dialog]');
      this.stage = this.querySelector('[data-zoom-stage]');
      this.desktop = window.matchMedia('(min-width: 60em)');

      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.select(thumb.dataset.mediaId)));

      this.querySelectorAll('[data-zoom-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openZoom(trigger.dataset.zoomSrc, trigger.dataset.zoomAlt));
        trigger.addEventListener('mousemove', (e) => this.hoverZoom(e, trigger));
        trigger.addEventListener('mouseleave', () => this.resetZoom(trigger));
      });
      this.querySelectorAll('[data-zoom-close]').forEach((el) => el.addEventListener('click', () => this.dialog.close()));
      if (this.dialog) this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog || e.target.tagName === 'IMG') this.dialog.close(); });

      // Switch media when the variant changes.
      this.onVariant = (e) => { if (e.detail && e.detail.mediaId) this.select(String(e.detail.mediaId)); };
      document.addEventListener('variant:change', this.onVariant);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this.onVariant);
    }

    select(mediaId) {
      if (!mediaId || mediaId === '0') return;
      const slide = this.slides.find((s) => s.dataset.mediaId === mediaId);
      if (!slide) return;
      this.slides.forEach((s) => s.classList.toggle('is-active', s === slide));
      this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.mediaId === mediaId));
      if (!this.desktop.matches) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    hoverZoom(e, trigger) {
      if (!this.desktop.matches) return;
      const img = trigger.querySelector('img');
      if (!img) return;
      const rect = trigger.getBoundingClientRect();
      img.style.setProperty('--zoom', '1.8');
      img.style.setProperty('--zoom-x', `${((e.clientX - rect.left) / rect.width) * 100}%`);
      img.style.setProperty('--zoom-y', `${((e.clientY - rect.top) / rect.height) * 100}%`);
    }

    resetZoom(trigger) {
      const img = trigger.querySelector('img');
      if (img) img.style.setProperty('--zoom', '1');
    }

    openZoom(src, alt) {
      if (!this.dialog || !src) return;
      this.stage.innerHTML = '';
      const img = document.createElement('img');
      img.src = src;
      img.alt = alt || '';
      this.stage.appendChild(img);
      this.dialog.showModal();
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.documentElement;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('reveal-ready');
    // Signal the head-script failsafe that reveal initialized (so it won't un-hide).
    window.__wmRevealReady = true;

    var supported = 'IntersectionObserver' in window;
    var observer = supported
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px' })
      : null;

    function scan() {
      var els = document.querySelectorAll('[data-reveal]:not(.is-revealed)');
      els.forEach(function (el) {
        if (el.dataset.revealBound) return;
        el.dataset.revealBound = '1';
        if (observer) observer.observe(el);
        else el.classList.add('is-revealed');
      });
    }

    if (document.readyState !== 'loading') scan();
    else document.addEventListener('DOMContentLoaded', scan);
    document.addEventListener('shopify:section:load', scan);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    class SizeGuide extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-size-guide]');
      this.onOpen = (e) => { if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); this.dialog.showModal(); } };
      document.addEventListener('click', this.onOpen);
      this.querySelectorAll('[data-size-guide-close]').forEach((el) => el.addEventListener('click', () => this.dialog.close()));
      this.dialog.addEventListener('click', (e) => {
        const box = this.dialog.getBoundingClientRect();
        const inside = e.clientX >= box.left && e.clientX <= box.right && e.clientY >= box.top && e.clientY <= box.bottom;
        if (!inside) this.dialog.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOpen);
    }
  }
  if (!customElements.get('size-guide')) customElements.define('size-guide', SizeGuide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["typography-fr"] && !Shopify.designMode) return;
  try {
    (function () {
      // Runs only on French locales (read from <html lang>) so no Liquid is
      // needed inside this bundled script.
      if (!/^fr/i.test(document.documentElement.lang || '')) return;
      var NNBSP = String.fromCharCode(0x202f);
      var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, KBD: 1, SAMP: 1 };

      function fix(value) {
        return value
          .replace(/([^\s])[   ]?([;!?])/g, '$1' + NNBSP + '$2')
          .replace(/«[   ]?/g, '«' + NNBSP)
          .replace(/[   ]?»/g, NNBSP + '»');
      }

      function walk(root) {
        if (!root) return;
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
          acceptNode: function (n) {
            var p = n.parentNode;
            if (!p || SKIP[p.nodeName] || p.isContentEditable) return NodeFilter.FILTER_REJECT;
            if (!n.nodeValue || !/[;!?«»]/.test(n.nodeValue)) return NodeFilter.FILTER_SKIP;
            return NodeFilter.FILTER_ACCEPT;
          },
        });
        var nodes = [], n;
        while ((n = walker.nextNode())) nodes.push(n);
        nodes.forEach(function (node) {
          var next = fix(node.nodeValue);
          if (next !== node.nodeValue) node.nodeValue = next;
        });
      }

      function run() {
        walk(document.querySelector('main'));
        walk(document.querySelector('.header-wrapper'));
        walk(document.querySelector('.footer'));
      }

      if (document.readyState !== 'loading') run();
      else document.addEventListener('DOMContentLoaded', run);
      document.addEventListener('shopify:section:load', run);
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'wm-wishlist';

    function read() {
      try { return JSON.parse(window.localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: list } }));
    }
    window.WMWishlist = {
      items: read,
      has: function (handle) { return read().indexOf(handle) > -1; },
      toggle: function (handle) {
        var list = read();
        var i = list.indexOf(handle);
        if (i > -1) list.splice(i, 1); else list.unshift(handle);
        write(list);
        return i === -1;
      },
    };

    class WishlistButton extends HTMLElement {
      connectedCallback() {
        this.handle = this.dataset.handle;
        this.button = this.querySelector('button');
        if (!this.button) return;
        this.onChange = () => this.sync();
        this.button.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.toggle(); });
        document.addEventListener('wishlist:change', this.onChange);
        this.sync();
      }
      disconnectedCallback() { document.removeEventListener('wishlist:change', this.onChange); }
      sync() {
        var active = window.WMWishlist.has(this.handle);
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (this.button.dataset.labelAdd) {
          this.button.setAttribute('aria-label', active ? this.button.dataset.labelRemove : this.button.dataset.labelAdd);
        }
        this.classList.toggle('is-active', active);
      }
      toggle() { window.WMWishlist.toggle(this.handle); }
    }
    if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);

    class WishlistCount extends HTMLElement {
      connectedCallback() {
        this.onChange = () => this.sync();
        document.addEventListener('wishlist:change', this.onChange);
        this.sync();
      }
      disconnectedCallback() { document.removeEventListener('wishlist:change', this.onChange); }
      sync() {
        var n = window.WMWishlist.items().length;
        this.textContent = n;
        this.classList.toggle('is-visible', n > 0);
      }
    }
    if (!customElements.get('wishlist-count')) customElements.define('wishlist-count', WishlistCount);

    // Sync any wishlist UI (counts, favourites list) to the stored state once the
    // core is ready — covers elements that upgraded before this script ran, so the
    // favourites page never renders empty when items exist. Deferred to the next
    // frame so custom elements defined in section bundles have connected.
    function syncAll() {
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: read() } }));
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(syncAll); });
    } else {
      requestAnimationFrame(syncAll);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
